import { useEffect } from "react";

// Sets document.title for a route, restoring the previous title on unmount.
// Replaces Next.js per-page `metadata`.
export function useDocumentTitle(title: string) {
  useEffect(() => {
    const previous = document.title;
    document.title = title;
    return () => {
      document.title = previous;
    };
  }, [title]);
}
